import "bootstrap/dist/css/bootstrap.min.css";

import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { initReactI18next } from "react-i18next";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    supportedLngs: ["en", "id"],
    fallbackLng: "en",
    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },
  });
const root = ReactDOM.createRoot(document.getElementById("root"));
const loadingFallback = (
  <div className="h-fit-screen w-full d-flex align-items-center justify-content-center">
    <div id="loading">
      <div id="loading-center" />
    </div>
  </div>
);
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <Suspense fallback={loadingFallback}>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </Suspense>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
